import { Link } from '../../lib/routing';
import { LegalLayout, LegalSection } from './legal-layout';

/* Conditions générales d'utilisation — v1, à finaliser par un juriste.
   Le volet données renvoie à la politique de confidentialité. */
export default function Terms() {
  return (
    <LegalLayout title="Conditions d'utilisation" updated="30 août 2026">
      <p>
        Ces conditions encadrent l'usage de Naïa, assistant pédagogique fondé sur l'intelligence
        artificielle, dans le cadre scolaire.
      </p>

      <LegalSection heading="Objet">
        <p>
          Naïa met à disposition des enseignants, des élèves et des responsables légaux un ensemble
          d'outils d'aide à l'apprentissage et à la correction. L'accès est fourni via l'établissement
          scolaire, qui reste responsable des comptes qu'il crée.
        </p>
      </LegalSection>

      <LegalSection heading="Usage attendu">
        <ul className="list-disc pl-5 flex flex-col gap-1">
          <li>Le service est destiné à un usage pédagogique.</li>
          <li>Les réponses sont générées par une IA : elles peuvent se tromper et doivent être vérifiées.</li>
          <li>L'assistant ne remplace ni un enseignant, ni un adulte de confiance, ni un professionnel.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Données personnelles">
        <p>
          Le traitement des données est décrit dans notre{' '}
          <Link to="/confidentialite" className="text-naia-blue underline inline-block py-3">politique de confidentialité</Link>.
          L'établissement est responsable de traitement, Naïa agit comme sous-traitant.
        </p>
      </LegalSection>

      <LegalSection heading="Responsabilités">
        <p>
          Naïa met en œuvre des mesures raisonnables de sécurité et de disponibilité. L'utilisateur
          s'engage à un usage conforme à ces conditions et à la réglementation applicable.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          Toute question :{' '}
          <a href="mailto:rgpd@naia-edu.com" className="text-naia-blue underline inline-block py-3">rgpd@naia-edu.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
